<template>
  <div class="widget-actions-compact">
    <el-button
      type="primary"
      size="large"
      :disabled="!canContinue"
      class="continue-button premium-button"
      @click="emit('continue')"
    >
      {{ label }}
    </el-button>
  </div>
</template>

<script setup lang="ts">
defineProps<{ canContinue: boolean; label: string }>();

const emit = defineEmits<{ continue: [] }>();
</script>

<style scoped>
.widget-actions-compact {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.continue-button.premium-button {
  width: auto;
  height: var(--ui-button-height);
  padding: 0 20px;
  border-radius: var(--ui-radius-button);
  font-size: 13px;
  font-weight: 600;
  border: none;
  background: var(--ui-accent);
  color: #fff;
  transition: background-color 0.15s ease;
}

.continue-button.premium-button:hover:not(:disabled) {
  background: var(--ui-accent-deep);
}

.continue-button:disabled {
  background: var(--ui-bg-disabled);
  color: var(--ui-text-disabled);
  cursor: not-allowed;
  opacity: 1;
}

@media (max-width: 639px) {
  .continue-button.premium-button {
    width: 100%;
  }
}
</style>
